import auth from './auth.module'

const modules = {
  auth
}

export default modules
